// extracted by mini-css-extract-plugin
export default {"candidate-details":"CandidateDetails_candidate-details__XeGWl"};